// extracted by mini-css-extract-plugin
export default {"Button":"CancelButton_Button__MHMoY","LoggedIn":"CancelButton_LoggedIn__PIkBf","Mobile":"CancelButton_Mobile__jskVa"};